import { computed, createApp, defineComponent, h } from 'vue';
import { createPinia } from 'pinia';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'remixicon/fonts/remixicon.css';
import '@design-system/tokens.css';
import './styles.css';
import App from './App.vue';
import router from './router';
import { registerLoadingButton } from '@design-system/loading-button';

const app = createApp(App)
  .use(createPinia())
  .use(router)
  .use(Antd);
registerLoadingButton(app, { computed, defineComponent, h });
app.mount('#app');
